var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"b-container",attrs:{"fluid":""}},[_c('v-row',{staticClass:"pl-4"},[_c('h3',[_vm._v("Coupon Details Page")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }